import React from "react";
import styles from "./StatisticsBox.module.css";

const StatisticsBox = ({ stats, wowComparison }) => {
  // Safety check for stats
  if (!stats) {
    return <div className={styles.statisticsBox}>Loading statistics...</div>;
  }

  const getTrendIcon = (trend) => {
    if (trend === "up") return "↑";
    if (trend === "down") return "↓";
    return "→";
  };

  const getTrendClass = (trend) => {
    if (trend === "up") return styles.trendUp;
    if (trend === "down") return styles.trendDown;
    return styles.trendSame;
  };

  const getCompletionColor = (percentage) => {
    const pct = parseFloat(percentage) || 0;
    if (pct >= 80) return styles.statusReady;
    if (pct >= 60) return styles.statusCaution;
    return styles.statusCritical;
  };

  const safeNumber = (value, decimals = 1) => {
    const num = parseFloat(value);
    return isNaN(num) ? "0.0" : num.toFixed(decimals);
  };

  const safeInteger = (value) => {
    const num = parseInt(value);
    return isNaN(num) ? 0 : num;
  };

  return (
    <div className={styles.statisticsBox}>
      <div className={styles.statMain}>
        <h2>Overall Completion</h2>
        <div
          className={`${styles.completionDisplay} ${getCompletionColor(
            stats.overall_completion
          )}`}
        >
          <span className="percentage">
            {safeNumber(stats.overall_completion)}%
          </span>
          {wowComparison && wowComparison.change !== null && (
            <span className={`trend ${getTrendClass(wowComparison.trend)}`}>
              {getTrendIcon(wowComparison.trend)}{" "}
              {safeNumber(Math.abs(wowComparison.change))}%
            </span>
          )}
        </div>
        {wowComparison && wowComparison.previousCompletion !== null && (
          <p className={styles.wowText}>
            vs. {safeNumber(wowComparison.previousCompletion)}% last week
          </p>
        )}
      </div>

      <div className={styles.statGrid}>
        <div className={styles.statItem}>
          <span className={styles.statLabel}>Total Employees</span>
          <span className={styles.statValue}>
            {safeInteger(stats.total_employees).toLocaleString()}
          </span>
        </div>
        <div className={styles.statItem}>
          <span className={styles.statLabel}>Completed</span>
          <span className={`${styles.statValue} ${styles.statReady}`}>
            {safeInteger(stats.employees_completed).toLocaleString()}
          </span>
        </div>
        <div className={styles.statItem}>
          <span className={styles.statLabel}>In Progress</span>
          <span className={`${styles.statValue} ${styles.statCaution}`}>
            {safeInteger(stats.employees_in_progress).toLocaleString()}
          </span>
        </div>
        <div className={styles.statItem}>
          <span className={styles.statLabel}>Not Started</span>
          <span className={`${styles.statValue} ${styles.statCritical}`}>
            {safeInteger(stats.employees_not_started).toLocaleString()}
          </span>
        </div>
      </div>

      {stats.total_locations !== undefined && (
        <div className={styles.locationStats}>
          <h3>Location Status</h3>
          <div className={styles.locationGrid}>
            <div className={`${styles.locationStat} ${styles.ready}`}>
              <span className={styles.count}>
                {safeInteger(stats.locations_ready)}
              </span>
              <span className={styles.label}>Ready</span>
            </div>
            <div className={`${styles.locationStat} ${styles.caution}`}>
              <span className={styles.count}>
                {safeInteger(stats.locations_caution)}
              </span>
              <span className={styles.label}>Caution</span>
            </div>
            <div className={`${styles.locationStat} ${styles.critical}`}>
              <span className={styles.count}>
                {safeInteger(stats.locations_critical)}
              </span>
              <span className={styles.label}>Critical</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatisticsBox;
